import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { AppStateFacade } from '@app-state';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var NAMESPACE = 'UiPath.Server.Configuration.OData';
var QueueItemEventService = /** @class */ (function (_super) {
    tslib_1.__extends(QueueItemEventService, _super);
    function QueueItemEventService(http, _a) {
        var authConfig = _a.authConfig;
        var _this = _super.call(this, http, MapperService.queueItemEventMap) || this;
        _this._endpoint = authConfig.odataBaseUrl + "/QueueItemEvents";
        return _this;
    }
    QueueItemEventService.prototype.getByItem = function (queueItemId, queryOptions) {
        var _this = this;
        return this._http.get(this._endpoint + "/" + NAMESPACE + ".GetQueueItemEventsHistory(queueItemId=" + queueItemId + ")" + this.getQueryString(queryOptions)).pipe(map(function (response) { return _this._mapData(response); }));
    };
    return QueueItemEventService;
}(ODataService));
export { QueueItemEventService };
